import { render, staticRenderFns } from "./IdentityHome.vue?vue&type=template&id=5fc281fc&scoped=true&"
import script from "./IdentityHome.vue?vue&type=script&lang=js&"
export * from "./IdentityHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc281fc",
  null
  
)

export default component.exports